/* Sidebar Panels JavaScript/jQuery */
jQuery(function( $ ) {

	function escapeHtml() {
		return this.replace(/[&<>"]/g, function (s) {
			var entityMap = {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				'"': '&quot;',
			};

			return entityMap[s];
		});
	}


	if (typeof(String.prototype.escapeHtml) !== 'function') {
		String.prototype.escapeHtml = escapeHtml;
	}

	function linkify() {
		return this
		.replace(/[^@ \t\r\n"]+@[^@ \t\r\n"]+\.[^@ \t\r\n"]*[^@ \t\r\n.,;"]/, s => '<a target="_blank" href="mailto:' + s + '">' + s + '</a>')
		.replace(/https?:\/\/[^ \t\r\n"]+[^@ \t\r\n.,;"]/, s => '<a target="_blank" href="' + s + '">' + s + '</a>');
	}

	if (typeof(String.prototype.linkify) !== 'function') {
		String.prototype.linkify = linkify;
	}

	if ('function' !== typeof Date.prototype.toLocaleDateString) {
		Date.prototype.toLocaleDateString = function() {
			return this.toLocaleString().split(',')[0];
		}
	}

	function dateRangeToLocaleString(start, end) {
		//TODO: real timezone fix
		return new Date( start + ' 12:00' ).toLocaleDateString() +
			' - ' + new Date( end + ' 12:00' ).toLocaleDateString();
	}

	function compareLabel(a, b) {
		return a.label ? a.label.localeCompare( b.label ) : b.label ? -1 : 0;
	}

	// Loads on any interior page that has the v-gcq element
    sb_when( '#v-gcq', function() {
		let loadSearchListTimeout = null
		let loadCourseListPrenotificationId = null;
		let loadCourseListNotificationId = null;
		let teachersTimer = null;
		const teachersRefreshInterval = 120 * 1000; // every 2 min
		let planTimer = null;
		const planRefreshInterval = 240 * 1000;

		// handle course list pagination on scroll
		$( window ).on( 'scroll', _.debounce( function() {
			const scrollTop = $( this ).scrollTop();
			const screenHeight = $( this ).innerHeight();
			const scrollHeight = $( 'body' )[0].scrollHeight;

			// ~ 600px from bottom of the page - this is pretty arbitrary but feels okay to me
			if ( scrollHeight - screenHeight - scrollTop < 600 ) {
				vmGCQ.incrementPage();
			}
		}, 100 ));

		function getRequestsUnreadCount(request) {
			if (!request || !request.events)
				return null;
			const lastReadId = request.lastReadId;
			const userId = window.vmGCQ.myProfile.userId;
			let count = 0;
			for (let event of request.events)
				if (event.id > lastReadId && event.by != userId)
					++count;
			return count;
		}

		function updateRequestConversation(data, request = undefined) {
			const requests = window.vmGCQ.myApprovalRequests;
			if (!data)
				return requests;
			if (!'id' in data) {
				if ('errorMessage' in data)
					console.error(data.errorMessage);
				return;
			}
			if (request === undefined) {
				for (let r of requests) {
					if (('id' in r && r.id) ? r.id == data.id : ('courseId' in r ? r.courseId == data.courseId : true)) {
						request = r;
						break;
					}
				}
			}
			if (request === undefined || request === null) {
				request = {};
				requests.push(request);
			}
			if ('events' in data) {
				request.events = data.events;
				request.unreadCount = getRequestsUnreadCount(data);
			}
			if ('prevRequestId' in data)
				request.prevRequestId = data.prevRequestId;
			if ('approvalStatus' in data)
				request.approvalStatus = data.approvalStatus;
			if ('timestampCreated' in data)
				request.timestampCreated = data.timestampCreated;
			if ('timestampUpdated' in data)
				request.timestampUpdated = data.timestampUpdated;
			if ('lastReadId' in data)
				request.lastReadId = data.lastReadId;
			request.loading = false;
			return requests;
		}

		// ajax actions

		function ajaxLoadSearchLists( notificationId ) {
			loadSearchListTimeout = null;
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action:  'get_search_lists',
					filters: (vmGCQ && vmGCQ.ajaxFilters) ? JSON.stringify( vmGCQ.ajaxFilters ) : undefined,
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax search lists request failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					vmGCQ.loadSearchLists( response.data || {} );
				},
				complete: function() {
					vmGCQ.loadingCourseList = false;
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxLoadSessionsForSelectedCourse( notificationId ) {
			loadSearchListTimeout = null;
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action:  'get_course_sessions',
					courseId: vmGCQ.selectedCourse.id,
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax course sessions request failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					vmGCQ.setSelectedCourseSessions( response.data || {} );
				},
				complete: function() {
					vmGCQ.loadingCourseList = false;
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxLoadMyTeachers(onComplete = null, onSuccess = null, onError = null) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'get_my_teachers',
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log('ajax myTeachers request failed', textStatus, teacherUserId);
					console.log(errorThrown);
					if (typeof onError === 'function')
						onError(errorThrown, textStatus);
				},
				success: function(response, textStatus, jqXHR) {
					vmGCQ.teachers = response.data;
					if (vmGCQ.teachers.length > 0 && (typeof vmGCQ.myPlanTeacherId === 'undefined' || vmGCQ.myPlanTeacherId === null)) {
						vmGCQ.setTeacher(vmGCQ.teachers[0].id);
					}
					if (typeof onSuccess === 'function')
						onSuccess();
				},
				complete: function() {
					if (teachersTimer)
						clearTimeout(teachersTimer);
					teachersTimer = setTimeout(() => ajaxLoadMyTeachers(), teachersRefreshInterval);
					if (typeof onComplete === 'function')
						onComplete();
				},
			});
		}

		function handleMyPlanAjaxResponse(response, teacherId = null ) {
			if (!response.success || !response.data)
				return false;
			try {
				vmGCQ.myPlan = response.data.myPlan;
				vmGCQ.myPlanCompleted = response.data.myPlanCompleted;
				vmGCQ.myPlanTeacherId = teacherId;
				if ('myProfile' in response.data) {
					vmGCQ.completedCredits = response.data.myProfile.completedCredits || 0;
					if (teacherId === null) {
						vmGCQ.myProfile = response.data.myProfile;
						vmGCQ.planUserId = vmGCQ.userId = response.data.myProfile.id;
						vmGCQ.profileFields = JSON.parse(JSON.stringify( response.data.myProfile ) ); // shallow copy...
						delete vmGCQ.profileFields.completedCredits;
					} else {
						response.data.myProfile.id = teacherId;
						vmGCQ.planUserId = teacherId;
						vmGCQ.teacher = response.data.myProfile;
					}
				}
				if ('myApprovalRequests' in response.data) {
					vmGCQ.myApprovalRequests = response.data.myApprovalRequests.map(r => {
						r.loading = false;
						r.collapsed = true;
						for (let old of vmGCQ.myApprovalRequests) {
							if (old.id == r.id) {
								r.collapsed = old.collapsed;
							}
						}
						r.unreadCount = getRequestsUnreadCount(r);
						return r;
					});
				} else {
					vmGCQ.myApprovalRequests = [];
				}
				vmGCQ.myNotifications = response.data.myNotifications;
				if ('myTranscripts' in response.data) {
					vmGCQ.myTranscripts = response.data.myTranscripts;
				}
				if ('teachers' in response.data) {
					vmGCQ.teachers = response.data.teachers;
					if (vmGCQ.teachers.length) {
						vmGCQ.setTeacher(vmGCQ.teachers[0].id);
					}
					if (teachersTimer)
						clearTimeout(teachersTimer);
					teachersTimer = setTimeout(() => ajaxLoadMyTeachers(), teachersRefreshInterval);
				}
				if ('unreadCount' in response.data) {
					vmGCQ.unreadCount = response.data.unreadCount;
				}
				return true;
			} catch (e) {
				console.error(e);
			}
			return false;
		}

		function ajaxLoadMyPlan( notificationId, teacherId = null ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'get_my_plan',
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax myPlan request failed', textStatus, teacherId );
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					if (!handleMyPlanAjaxResponse(response, teacherId)) {
						console.log( "There was an error when trying to get " + (teacherId ? 'teacher plan' : 'my plan') );
						console.log(response);
					}
				},
				complete: function() {
					vmGCQ.refreshingMyPlan = false;
					if (teacherId === null) {
						vmGCQ.loadingMyPlan = false;
					} else {
						vmGCQ.loadingTeacherPlan = false;
					}
					if (planTimer)
						clearTimeout(planTimer);
					planTimer = setTimeout(() => ajaxLoadMyPlan(null, teacherId), planRefreshInterval);
					if (notificationId)
						vmNotificationManager.removeNotification(notificationId);
				},
			});
		}

		function ajaxSendApprovalRequest( courseId, notificationId, teacherId = null ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'send_approval_request',
					courseId: courseId,
					teacherId: teacherId,
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax sending request failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					window.vmGCQ.myApprovalRequests = updateRequestConversation(response.data)
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxSendApprovalRequestComment(approvalRequest, comment, notificationId, teacherId = null) {
			approvalRequest.loading = true;
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'comment_approval_request',
					requestId: approvalRequest.id,
					comment: comment,
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					request.loading = false;
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax request comment failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					window.vmGCQ.myApprovalRequests = updateRequestConversation(response.data, approvalRequest)
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxAcceptApprovalRequest(approvalRequest, comment, notificationId, teacherId = null) {
			approvalRequest.loading = true;
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'approve_approval_request',
					requestId: approvalRequest.id,
					comment: comment,
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					request.loading = false;
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax acceptance request failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					updateRequestConversation(response.data, approvalRequest)
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxCompleteReview(approvalRequest, comment, notificationId, teacherId = null, eventId = null) {
			approvalRequest.loading = true;
			if (eventId == null) {
				const userId = window.vmGCQ.myProfile.userId;
				for (let event of approvalRequest.events)
					if (eventId < event.id && event.by != userId)
						eventId = event.id;
			}
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'complete_requested_review',
					requestId: approvalRequest.id,
					comment: comment,
					teacherId: JSON.stringify(teacherId),
					eventId: JSON.stringify(eventId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					request.loading = false;
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax completion request failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					updateRequestConversation(response.data, approvalRequest)
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxGetApprovalRequest(approvalRequest, notificationId, teacherId = null) {
			approvalRequest.loading = true;
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'get_approval_request',
					requestId: approvalRequest.id,
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					request.loading = false;
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax fetching review request failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					window.vmGCQ.myApprovalRequests = updateRequestConversation(response.data, approvalRequest)
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxSendMarkApprovalRequestRead(approvalRequest, notificationId, eventId = null, teacherId = null) {
			if (eventId == null) {
				const userId = window.vmGCQ.myProfile.userId;
				for (let event of approvalRequest.events)
					if (eventId < event.id && event.by != userId)
						eventId = event.id;
				if (eventId == null)
					return;
			}
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'read_approval_request',
					requestId: approvalRequest.id,
					eventId: JSON.stringify(eventId),
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax marking request read failed', textStatus);
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					window.vmGCQ.myApprovalRequests = updateRequestConversation(response.data, approvalRequest)
				},
				complete: function() {
					vmNotificationManager.removeNotification(notificationId);
				},
			});
		}

		function ajaxSendMarkAllApprovalRequestsRead(notificationId, teacherId = null) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'read_all_user_approval_requests',
					teacherId: JSON.stringify(teacherId || vmGCQ.planUserId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log('ajax mark all course conversations read failed', textStatus, teacherId);
					console.log(errorThrown);
				},
				success: function(response, textStatus, jqXHR) {
					if (!handleMyPlanAjaxResponse(response, teacherId)) {
						console.log("There was an error when trying to get " + (teacherId ? 'teacher plan' : 'my plan'));
						console.log(response);
					}
				},
				complete: function() {
					if (notificationId)
						vmNotificationManager.removeNotification(notificationId);
				},
			});
		}

		function ajaxAddToMyPlan( courseId, notificationId, completed, teacherId = null ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'add_to_my_plan',
					courseId: courseId,
					completed: completed ? '1' : undefined,
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				success: function(response, textStatus, jqXHR) {
					if (!handleMyPlanAjaxResponse(response, teacherId)) {
						console.log("There was an error when trying to add to " + (teacherUserId ? 'teacher plan' : 'my plan'));
						console.log(response);
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax addToMyPlan request failed', textStatus);
					console.log( errorThrown );
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
					// CODE HERE!!!
				},
			});
		}

		function ajaxClearMyPlan( notificationId, teacherId = null ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'clear_my_plan',
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				success: function(response, textStatus, jqXHR) {
					if (!handleMyPlanAjaxResponse(response, teacherId)) {
						console.log("There was an error when trying to remove from " + (teacherUserId ? 'teacher plan' : 'my plan'));
						console.log(response);
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax clearMyPlan request failed', textStatus);
					console.log( errorThrown );
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxRemoveFromMyPlan( courseId, notificationId, teacherId = null ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'remove_from_my_plan',
					courseId: courseId,
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					vmNotificationManager.addErrorNotification();
					console.log( 'ajax removeFromMyPlan request failed', textStatus);
					console.log( errorThrown );
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				}
			});
		}

		function ajaxUpdateProfile( notificationId ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'update_profile',
					firstName:			vmGCQ.profileFields.firstName,
					lastName:			vmGCQ.profileFields.lastName,
					phone:				vmGCQ.profileFields.phone,
					schoolDistrict:		vmGCQ.profileFields.schoolDistrict,
					schoolDistricts:		vmGCQ.profileFields.schoolDistricts,
					state:				vmGCQ.profileFields.state,
					dualCreditInstitutions:	vmGCQ.profileFields.dualCreditInstitutions,
					dualCreditInstitution:	vmGCQ.profileFields.dualCreditInstitution,
					approverEmail:	    vmGCQ.profileFields.approverEmail,
					approverName:	    vmGCQ.profileFields.approverName,
					autoRequestApproval:	vmGCQ.profileFields.autoRequestApproval,
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax Update Profile request failed', textStatus);
					vmNotificationManager.addErrorNotification();
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					if ( ! response.success ) {
						console.log( response.data );
						vmNotificationManager.addErrorNotification( response.data );
					} else {
						$( '.edit-profile-form' ).collapse( 'hide' );
					}
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxUpdateCompletedCredits( notificationId, teacherId = null ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'update_profile_completed_credits',
					completedCredits: vmGCQ.completedCredits,
					teacherId: JSON.stringify(teacherId),
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax Update completed request failed', textStatus);
					vmNotificationManager.addErrorNotification();
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					if ( ! response.success ) {
						console.log( response.data );
						vmNotificationManager.addErrorNotification( response.data );
					} else {
						$( '.edit-profile-form' ).collapse( 'hide' );
					}
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxUpdatePassword( notificationId ) {
			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: {
					action: 'update_password',
					currentPassword: vmGCQ.passwordFields.password,
					newPassword: vmGCQ.passwordFields.newPassword,
				},
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax Update Profile request failed', textStatus);
					vmNotificationManager.addErrorNotification();
					console.log( errorThrown );
				},
				beforeSend: function() {
					$( '.change-password-form' ).collapse( 'hide' );
					vmGCQ.passwordFields.password = '';
					vmGCQ.passwordFields.newPassword = '';
				},
				success: function(response, textStatus, jqXHR) {
					if ( ! response.success ) {
						console.log( response.data );
						vmNotificationManager.addErrorNotification( response.data );
					} else {}
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxUpdateProfileImage( notificationId ) {

			let formData = new FormData();
			if ( $( '.navbar-toggler' ).css( 'display' ) == 'none' ) {
				formData.append( 'file',  $( '.profile-image-field' )[0].files[0] );
			} else {
				formData.append( 'file',  $( '.profile-image-field' )[1].files[0] );
			}

			formData.append('action', 'update_profile_image');

			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: formData,
				processData: false,
				contentType: false,
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax Update Profile request failed', textStatus);
					vmNotificationManager.addErrorNotification();
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					if ( ! response.success ) {
						console.log( response.data );
						vmNotificationManager.addErrorNotification( response.data );
					} else {
						$( '.update-profile-image-form' ).collapse( 'hide' );
						$( '.profile-image-field' ).each( function() {
							$( this ).replaceWith( $( this ).val('').clone(true));
						});
						vmGCQ.myProfile.profileImage = response.data.fileName;
					}
				},
				complete: function() {
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		function ajaxUploadTranscript( notificationId ) {

			let formData = new FormData();
			formData.append( 'file',  $( '.save-transcript-field' )[0].files[0] );

			formData.append('action', 'save_transcript');

			$.ajax({
				url: ajax_object.ajax_url,
				method: 'post',
				data: formData,
				processData: false,
				contentType: false,
				timeout: 60 * 1000, // 1 minute
				error: function(jqXHR, textStatus, errorThrown) {
					console.log( 'ajax Save Transcript request failed', textStatus);
					vmNotificationManager.addErrorNotification();
					console.log( errorThrown );
				},
				success: function(response, textStatus, jqXHR) {
					if ( ! response.success ) {
						console.log( response.data );
						vmNotificationManager.addErrorNotification( response.data );
					} else {
						$( '.save-transcript-field' ).each( function() {
							$( this ).replaceWith( $( this ).val('').clone(true));
						});
						vmGCQ.myTranscripts = response.data.transcripts;
						vmGCQ.lastUploadedTranscriptId = response.data.updatedId;
					}
				},
				complete: function() {
					vmGCQ.uploadingTranscript = false;
					vmNotificationManager.removeNotification( notificationId );
				},
			});
		}

		// autoclose on outside click
		$( document ).on( 'click touchstart', function(e) {

			$( '.autoclose' ).each( function( index, obj ) {
				const target = $( obj ).data( 'target' );

				if (
					$( e.target ).hasClass( 'autoclose' )
					&& $( e.target ).data( 'target' ) == target )
				{
					return;
				}
				if ( $( e.target ).closest( '.autoclose' ).length != 0
					&& $( e.target ).closest( '.autoclose' ).data( 'target' ) == target )
				{
					return;
				}
				$( target ).collapse( 'hide' );
			});

		});

		// delegated event handlers for logged in users
        if ( $( '.dashboard').length ) { // is logged in

            $( document ).on( 'click', '.remove-selected-from-my-plan', function( e ) {
                e.preventDefault();
                const courseId = vmGCQ.selectedCourse.id;
                vmGCQ.removeFromMyPlan( courseId );
            });

            $( document ).on( 'click', '.add-selected-to-my-plan', function( e ) {
                e.preventDefault();
                const courseId = vmGCQ.selectedCourse.id;
                vmGCQ.addToMyPlan( courseId, false );
            });

            $( document ).on( 'click', '.add-selected-to-my-plan-completed', function( e ) {
                e.preventDefault();
                const courseId = vmGCQ.selectedCourse.id;
                vmGCQ.addToMyPlan( courseId, true );
            });

            $( document ).on( 'click', '.remove-from-my-plan', function( e ) {
                e.preventDefault();
                const courseId = $( e.currentTarget ).data( 'course-id' );
                vmGCQ.removeFromMyPlan( courseId );
            });

            $( document ).on( 'click', '.add-to-my-plan', function( e ) {
                e.preventDefault();
                const courseId = $( e.currentTarget ).data( 'course-id' );
                vmGCQ.addToMyPlan( courseId, false );
            });

            $( document ).on( 'click', '.add-to-my-plan-completed', function( e ) {
                e.preventDefault();
                const courseId = $( e.currentTarget ).data( 'course-id' );
                vmGCQ.addToMyPlan( courseId, true );
            });

		} // end event handlers for logged in users


		const course_sortings = {
			"": function(a, b) {
				return 0;
			},
			"number_asc": function(a, b) {
				return a.number ? a.number.localeCompare(b.number) : b.number ? -1 : 0;
			},
			"number_desc": function(a, b) {
				return b.number ? b.number.localeCompare(a.number) : a.numberr ? -1 : 0;
			},
			"title_asc": function(a, b) {
				return a.title ? a.title.localeCompare(b.title) : b.title ? -1 : 0;
			},
			"title_desc": function(a, b) {
				return b.title ? b.title.localeCompare(a.title) : a.title ? -1 : 0;
			},
			// TODO: maybe fix
			/*"credits_asc": function(a, b) {
				return a.credits - b.credits;
			},
			"credits_desc": function(a, b) {
				return b.credits - a.credits;
			},*/
		};

		const reviewRequestRefreshDelay = 60000;
		const reviewRequestRefreshTimers = {};

        window.vmGCQ = new Vue({
            el: '#v-gcq',
            data: {

				// Course List Data
				selectedCourse: [],
				selectedCourseSessions: [],
	            courseList: [],
				universityList: [],
				universityMap: {},
				sessionDatesList: [],
				sessionDatesMap: {},
				fieldOfStudyList: [],
				fieldOfStudyMap: {},
				maxCredits: 5,

				// Course List Filter Variables
				fieldOfStudyValues: [],
				fieldOfStudySet: null,
				availableOnline: false,
				filterKeywords: '',
				universityValues: [],
				universitySet: null,
				sessionDatesIdsValues: [],
				sessionDatesIdsSet: null,
				creditsValues: [],
				creditsSet: null,
				earliestStartDate: null,
				latestEndDate: null,

				// Course List Pagination ( inifinite scroll technique )
				page: 1,
				numPerPage: 5,

				// User Specific Data
                myPlan: [],
                myPlanCompleted: [],
				myApprovalRequests: [],
				myProfile: {
					userId: null,
					autoRequestApproval: null,
				},
				myNotifications: [],
				myTranscripts: [],
				lastUploadedTranscriptId: null,
				uploadingTranscript: false,
				completedCredits: 0,
				transcripts: [],
				// Coordinator Specific Data
				teachers: null,
				teacher: null,
				planUserId: null,
				userId: null,
				unreadCount: null,
				teacherSignUpInfo: {
					firstName: null,
					lastName: null,
					email: null,
					phone: null,
					completedCredits: 0,
					state: '',
					dualCreditInstitutions: null,
					autoRequestApproval: 1,
				},

				// User Specific Form Field Data
				profileFields: {},
				passwordFields: {},

				// Flags
				loadingCourseList: true,
				loadingMyPlan: true,
				refreshingMyPlan: false,
				loadingTeacherPlan: false,
				userLoggedIn: $( '.dashboard' ).length,
				activeTab: 2,
				deliveryOptionsArray: ['Classroom', 'Online', 'Hybrid', 'Synchronous Online', 'Asynchronous Online'],
				sorting: "title_asc",
				sortingFunc: null,
				sortingOptions: [
					{
						id: "",
						label: "None",
					},
					{
						id: "number_asc",
						label: "Number",
					},
					{
						id: "number_desc",
						label: "Number - Reverse",
					},
					{
						id: "title_asc",
						label: "Title",
					},
					{
						id: "title_desc",
						label: "Title - Reverse",
					},
					/*{
						id: "credits_asc",
						label: "Credits - Low to High",
					},
					{
						id: "title_desc",
						label: "Credits - High to Low",
					},*/
				],
				regions: {
					'AL': 'Alabama',
					'AK': 'Alaska',
					'AZ': 'Arizona',
					'AR': 'Arkansas',
					'CA': 'California',
					'CO': 'Colorado',
					'CT': 'Connecticut',
					'DE': 'Delaware',
					'DC': 'District of Columbia',
					'FL': 'Florida',
					'GA': 'Georgia',
					'HI': 'Hawaii',
					'ID': 'Idaho',
					'IL': 'Illinois',
					'IN': 'Indiana',
					'IA': 'Iowa',
					'KS': 'Kansas',
					'KY': 'Kentucky',
					'LA': 'Louisiana',
					'ME': 'Maine',
					'MD': 'Maryland',
					'MA': 'Massachusetts',
					'MI': 'Michigan',
					'MN': 'Minnesota',
					'MS': 'Mississippi',
					'MO': 'Missouri',
					'MT': 'Montana',
					'NE': 'Nebraska',
					'NV': 'Nevada',
					'NH': 'New Hampshire',
					'NJ': 'New Jersey',
					'NM': 'New Mexico',
					'NY': 'New York',
					'NC': 'North Carolina',
					'ND': 'North Dakota',
					'OH': 'Ohio',
					'OK': 'Oklahoma',
					'OR': 'Oregon',
					'PA': 'Pennsylvania',
					'RI': 'Rhode Island',
					'SC': 'South Carolina',
					'SD': 'South Dakota',
					'TN': 'Tennessee',
					'TX': 'Texas',
					'UT': 'Utah',
					'VT': 'Vermont',
					'VA': 'Virginia',
					'WA': 'Washington',
					'WV': 'West Virginia',
					'WI': 'Wisconsin',
					'WY': 'Wyoming',
					'AS': 'American Samoa',
					'GU': 'Guam',
					'MP': 'Northern Mariana Islands',
					'PR': 'Puerto Rico',
					'VI': 'U.S. Virgin Islands',
					'FM': 'Micronesia',
					'MH': 'Marshall Islands',
					'PW': 'Palau',
				},
			},
			created: function() {
				window.vmGCQ = this;
				// load local copy of course list data for speed
				this.localStorageLoadCourseList();
				// load remote copy of course list data for accuracy
				const notificationId = vmNotificationManager.addInfoNotification( 'Updating Search Lists' );
				ajaxLoadSearchLists( notificationId );
				// load user profile data if logged in
				if ( this.userLoggedIn ) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Loading User Profile' );
					ajaxLoadMyPlan( notificationId );
				} else {
					this.loadingMyPlan = false;
				}
			},
			mounted() {
				var state = document.getElementById('teacherSignUpInfo_state');
				state.setCustomValidity(state.selectedIndex > 0 ? '' : 'Select state.');
			},
			computed: {
				myPlanIds: function() {
					return this.myPlan.filter( e => e ).map( entry => entry.id );
				},
				myPlanCompletedIds: function() {
					return this.myPlanCompleted.filter( e => e ).map( entry => entry.id );
				},
				myPlanAllIds: function() {
					return Array.from( new Set( this.myPlanIds.concat( this.myPlanCompletedIds ) ) );
				},
				myPlanCompletedCredits: function() {
					return this.myPlanCompleted.reduce((a, b) => a + ((b.credits.length == 1) ? parseInt(b.credits) : 0), 0);
				},
				otherCompletedCredits: function() {
					return this.completedCredits - this.myPlanCompletedCredits;
				},
				// Credit Count Functions
				scheduledCredits: function() {
					return this.myPlan.filter( c => c ).reduce( function( accumulator, currentValue ) {
						return accumulator + ((currentValue.credits.length == 1) ? parseInt( currentValue.credits ) : 0);
						
					}, 0 );
				},
				completedCreditsPercent: function() {
					return Math.ceil( this.completedCredits / 18 * 100 );
				},
				progressTrackerImageClass: function() {
					if( this.completedCredits == 0 ) {
						return 'level-1';
					}
					else if( this.completedCredits <= 9 ) {
						return 'level-2';
					}
					else if( this.completedCredits <= 12 ) {
						return 'level-3';
					}
					else if( this.completedCredits < 18 ) {
						return 'level-4';
					}
					return 'level-5';
				},
				progressTrackerLevelOneClass: function() {
					if( this.completedCredits <= 0 ) {
						return 'active';
					}
				},
				progressTrackerLevelTwoClass: function() {
					if( this.completedCredits > 0 && this.completedCredits <= 9 ) {
						return 'active';
					}
				},
				progressTrackerLevelThreeClass: function() {
					if( this.completedCredits > 9 && this.completedCredits <= 12 ) {
						return 'active';
					}
				},
				progressTrackerLevelFourClass: function() {
					if( this.completedCredits > 12 && this.completedCredits < 18 ) {
						return 'active';
					}
				},
				progressTrackerLevelFiveClass: function() {
					if( this.completedCredits >= 18 ) {
						return 'active';
					}
				},
				progressTrackerLevel: function() {
					if (this.completedCredits >= 18)
						return 5;
					if (this.completedCredits > 12)
						return 4;
					if (this.completedCredits > 9)
						return 3;
					if (this.completedCredits > 0)
						return 2;
					return 1;
				},
				// Profile Functions
				displayName: function(){
					return ( this.myProfile.firstName || this.myProfile.lastName )
						? ( this.myProfile.firstName + ' ' + this.myProfile.lastName ).trim()
 						: this.myProfile.login;
				},
				profileImageUrl: function() {
					if ( this.myProfile.profileImage ) {
						return 'url( /wp-content/uploads/profile-images/' + this.myProfile.profileImage + ')';
					}
					return '';
				},
				missingProfileFields: function() {
					const fields = [];
					if ( 'string' == typeof this.myProfile.firstName && this.myProfile.firstName == '' ) {
						fields.push( 'First Name' );
					}
					if ( 'string' == typeof this.myProfile.lastName && this.myProfile.lastName == '' ) {
						fields.push( 'Last Name' );
					}
					if ( 'string' == typeof this.myProfile.phone && this.myProfile.phone == '' ) {
						fields.push( 'Phone' );
					}
					if ( 'string' == typeof this.myProfile.schoolDistrict && this.myProfile.schoolDistrict == '' ) {
						fields.push( 'School District' );
					}
					if ( 'string' == typeof this.myProfile.state && this.myProfile.state == '' ) {
						fields.push( 'State' );
					}
					if ( 'string' == typeof this.myProfile.dualCreditInstitutions && this.myProfile.dualCreditInstitutions == '' ) {
						fields.push( 'Dual Credit Institution(s)' );
					}
					if ( 'string' == typeof this.myProfile.dualCreditInstitution && this.myProfile.dualCreditInstitution == '' ) {
						fields.push( 'Dual Credit Institution' );
					}

					return fields;
				},
				// Course List Filters
				filteredCourseList: function() {
					const self = this;
					let filteredList = this.courseList;
					console.log(filteredList);
					if ( this.fieldOfStudySet ) {
						filteredList = filteredList.filter( x => self.fieldOfStudySet.has( x.field ) );
					}
					if ( this.availableOnline ) {
						filteredList = filteredList.filter( x => 2 <= x.delivery );
					}
					if ( this.universitySet ) {
						filteredList = filteredList.filter( x => self.universitySet.has( x.school ) );
					}
					if ( this.sessionDatesIdsSet ) {
						filteredList = filteredList.filter( x => x.dates.some( t => self.sessionDatesIdsSet.has( t ) ) );
					}
					if ( this.creditsSet ) {
						filteredList = filteredList.filter( x => self.creditsSet.has( (x.credits.length > 1) ? 'Variable' : parseInt(x.credits) ) );
					}
					if ( this.filterKeywords ) {
						// could use split to split into separate words and search them all individually in a loop
						const keywords = (this.filterKeywords || '').toString().trim().toLowerCase();
						const searchableFields = [
							'number', 'title', 'courseDescription', 'field', 'school',
							'delivery', 'facultyContact', 'onlineResources'
						];

						filteredList = filteredList.filter( function( course ) {
							let field, fieldIndex;

							for ( fieldIndex in searchableFields ) {
								field = searchableFields[ fieldIndex ];
								let value = course[field];
								if ( "string" != typeof value ) {
									switch ( field ) {
										case 'delivery':
											value = self.deliveryOptionsArray[ value - 1 ] || null;
											break;
										case 'school':
											value = self.getNickNameBySchoolId( value );
											break;
									}
								}
								if ( "string" == typeof value && -1 != value.toLowerCase().indexOf( keywords ) ) {
									return true;
								}
							}
							return false;
						});
					}
					this.page = 1;
					try {
						return filteredList.sort( course_sortings[this.sorting || ""] || null );
					} catch (ex) {
						console.error(this, this.sorting || "", course_sortings[this.sorting || ""] || null);
						console.error(ex);
						return filteredList;
					}
				},
				// Pagination Functions
				visibleCourseList: function() {
					return this.filteredCourseList.slice( 0, this.page * this.numPerPage );
				},
				maxNumPages: function() {
					return Math.ceil( this.filteredCourseList.length / this.numPerPage );
				},
				// Filter Options
				fieldOfStudyOptions: function() {
					try {
					return this.fieldOfStudyList.filter( f => f.name ).map( f => ({ id: f.id, label: f.name }) )
						.sort( (a, b) => a.label ? a.label.localeCompare( b.label ) : b.label ? -1 : 0 );
					} catch (e) {
						console.log('fieldOfStudyOptions', this.fieldOfStudyList);
						console.error(e);
					}
				},
				creditsOptions: function() {
					var creditsArray = Array.from( new Array( this.maxCredits ), (value, index) => ({ id: index + 1, label: index + 1 }) );
					creditsArray.push({id: 'Variable', label: 'Variable'});
					return creditsArray;
				},
				universityOptions: function() {
					const self = this;
					const schools = this.universityList;
					const states = Array.from( new Set( schools.map( school => (school.state || '').toUpperCase() ) ) );
					//console.log('universityOptions()', { states: states });
					try {
					return states.map( state => ({
						id: 'state:' + state,
						label: (this.regions[state] || state),
						children: schools.filter( school => school.state == state ).map( school => ({
							id: "id:" + school.id,
							label: school.nickname || school.name,
						}) ).sort(compareLabel)
					}) ).sort(compareLabel);
					} catch (e) {
						console.log('universityOptions()', { universityList: schools, regions: this.regions });
						console.error(e);
					}
				},
				courseListIsFiltered: function() {
					return (
						null != this.fieldOfStudySet
						|| this.availableOnline
						|| this.universitySet
						|| this.sessionDatesIdsSet
						|| this.creditsSet
						|| this.earliestStartDate
						|| this.latestEndDate
						|| '' != this.filterKeywords
					);
				},

				ajaxFilters() {
					const filters = {};
					let has = false;
					if ( this.universitySet && this.universitySet.size ) {
						filters.schools = Array.from(this.universitySet );
						has = true;
					}
					if ( this.fieldOfStudyValues && this.fieldOfStudyValues.length ) {
						filters.fields = Array.from( this.fieldOfStudyValues );
						has = true;
					}
					if ( this.earliestStartDate ) {
						filters.sessionEarliest = this.earliestStartDate
						has = true;
					}
					if ( this.latestEndDate ) {
						filters.sessionLatest = this.latestEndDate
						has = true;
					}
					if ( this.creditsValues && this.creditsValues.length ) {
						filters.credits = Array.from( this.creditsValues );
					}
					if ( this.availableOnline ) {
						filters.delivery = [2];
					}
					return has ? filters : undefined;
				},
				teacherSignUpUrl() {
					const info = this.teacherSignUpInfo;
					return location.protocol + '//' + location.host + '/teacher-sign-up/?firstName=' + encodeURIComponent(info.firstName || '')
						+ '&lastName=' + encodeURIComponent(info.lastName || '')
						+ '&email=' + encodeURIComponent(info.email || '')
						+ '&phone=' + encodeURIComponent(info.phone || '')
						+ '&completedCredits=' + encodeURIComponent(info.completedCredits || '')
						+ '&schoolDistrict=' + encodeURIComponent(info.schoolDistrict || '')
						+ '&state=' + encodeURIComponent(info.state || '')
						+ '&dualCreditInstitutions=' + encodeURIComponent(info.dualCreditInstitutions || '')
						+ '&autoRequestApproval=' + (info.autoRequestApproval ? '1' : '0')
						+ '&hasApprover=1'
						+ '&approverName=' + encodeURIComponent(this.myProfile.firstName + ' ' + this.myProfile.lastName)
						+ '&approverEmail=' + encodeURIComponent(this.myProfile.email)
					;
				},
			},
            methods: {
				loadSearchLists(data) {
					this.universityList = data.universityList;
					let map = {};
					if ( this.universityList ) {
						for (const university of this.universityList) {
							try {
								map[university.id.toString()] = university;
							} catch (e) {
								console.error(university, e);
							}
						}
					}
					this.universityMap = map;
					this.sessionDatesList = data.sessionDatesList;
					let sessionDatesMap = {};
					if ( this.sessionDatesList ) {
						for (const term of this.sessionDatesList) {
							try {
								sessionDatesMap[term.id.toString()] = term;
							} catch (e) {
								console.error(term, e);
							}
						}
					}
					this.sessionDatesMap = sessionDatesMap;
					this.fieldOfStudyList = data.fieldOfStudyList;
					let fieldOfStudyMap = {};
					if ( this.fieldOfStudyList ) {
						for (const field of this.fieldOfStudyList) {
							try {
								fieldOfStudyMap[field.id.toString()] = field;
							} catch (e) {
								console.error(field, e);
							}
						}
					}
					this.fieldOfStudyMap = fieldOfStudyMap;
					this.maxCredits = data.maxCredits;
					if ( 'courseList' in data )
						this.courseList = data.courseList;
					this.localStorageStoreCourseList();
				},

				setSelectedCourseSessions(sessions) {
					this.selectedCourseSessions = sessions;
				},

				getStateBySchoolId(id) {
					if ( !id )
						return null;
					try {
						const school = this.universityMap[id.toString()];
						return school ? school.state : null;
					} catch (e) {
						console.log('getStateBySchoolId() error', id);
						console.error(e);
					}
				},
				getNickNameBySchoolId(id) {
					if ( !id )
						return null;
					try {
						const school = this.universityMap[id.toString()];
						return school ? (school.nickname ? school.nickname : school.name) : null;
					} catch (e) {
						console.log('getNickNameBySchoolId() error', id);
						console.error(e);
					}
				},
				getFieldNameById(id) {
					if ( !id )
						return null;
					try {
						const field = this.fieldOfStudyMap[id.toString()];
						return field ? field.name : null;
					} catch (e) {
						console.log('getFieldNameById() error', id);
						console.error(e);
					}
				},
				getFieldImageFilenameById(id) {
					if ( !id )
						return null;
					try {
						const field = this.fieldOfStudyMap[id.toString()];
						return field ? field.imageFilename : null;
					} catch (e) {
						console.log('getFieldImageFilenameById() error', id);
						console.error(e);
						return null;
					}
				},
				getDeliveryFromIdIfId(value) {
					return Number.isInteger( value ) && self.deliveryOptionsArray[ value - 1 ] || value;
				},
				convertSessionDatesIdsToString(sessionDateIds) {
					const self = this;
					try {
						if (!sessionDateIds)
							return null;
						if (!sessionDateIds.map && self.sessionDatesMap[sessionDateIds.toString()]) {
							const dates = self.sessionDatesMap[sessionDateIds.toString()];
							return dateRangeToLocaleString(dates.start, dates.end);
						}
						return sessionDateIds
							? sessionDateIds.map( id => self.sessionDatesMap[id.toString()])
								.map( d => d ? dateRangeToLocaleString(d.start, d.end) : '' )
								.join( ', ' )
							: null;
					} catch (e) {
						console.log('convertSessionDatesIdsToString() error', sessionDateIds);
						console.error(e);
						return null;
					}
				},
				printMyPlan: function() {
		            let printContents = document.getElementById( 'my-courses-content' ).innerHTML;
		            let originalContents = document.body.innerHTML;
		            document.body.innerHTML = printContents;
					$( '.print-header' ).addClass( 'd-block' );
					$( '.my-plan-course' ).addClass( 'border' );
					$( '.my-plan-course' ).removeClass( 'shadow' );
					$( '.my-course__right-column .btn' ).addClass( 'd-none' );
					$( '.my-plan-course__approval-handle' ).addClass( 'd-none' );
					$( '.trash-bin' ).addClass( 'd-none' );
		            window.print();
		            document.body.innerHTML = originalContents;
		            location.reload();
				},
				setActiveTab: function( tab ) {
					this.activeTab = tab;
				},
				// Local Storage Methods
				localStorageLoadCourseList: function() {
					const courseList = JSON.parse( localStorage.getItem( 'courseList' ) );
					const universityList = JSON.parse( localStorage.getItem( 'universityList' ) );
					const sessionDatesList = JSON.parse( localStorage.getItem( 'sessionDatesList' ) );
					const fieldOfStudyList = JSON.parse( localStorage.getItem( 'fieldOfStudyList' ) );
					this.maxCredits = JSON.parse( localStorage.getItem( 'maxCredits' ) );
					if ( courseList ) {
						this.courseList = courseList;
						this.loadingCourseList = false;
					}
					if ( universityList ) {
						let map = {};
						for (const university of universityList) {
							try {
								map[university.id.toString()] = university;
							} catch (e) {
								console.error(university, e);
							}
						}
						this.universityList = universityList;
						this.universityMap = map;
					}
					if ( sessionDatesList ) {
						let map = {};
						for ( const sessionDates of sessionDatesList ) {
							try {
								map[sessionDates.id.toString()] = sessionDates;
							} catch (e) {
								console.error(sessionDates, e);
							}
						}
						this.sessionDatesList = sessionDatesList;
						this.sessionDatesMap = map;
					}
					if ( fieldOfStudyList ) {
						let map = {};
						for ( const fieldOfStudy of fieldOfStudyList ) {
							try {
								map[fieldOfStudy.id.toString()] = fieldOfStudy;
							} catch (e) {
								console.error(fieldOfStudy, e);
							}
						}
						this.fieldOfStudyList = fieldOfStudyList;
						this.fieldOfStudyMap = map;
					}
				},
				localStorageStoreCourseList: function() {
					if ( 'object' == typeof this.courseList ) {
						localStorage.setItem( 'courseList', JSON.stringify( this.courseList ) );
					}
					if ( 'object' == typeof this.universityList ) {
						localStorage.setItem( 'universityList', JSON.stringify( this.universityList ) );
					}
					if ( 'object' == typeof this.sessionDatesList ) {
						localStorage.setItem( 'sessionDatesList', JSON.stringify( this.sessionDatesList ) );
					}
					if ( 'object' == typeof this.fieldOfStudyList ) {
						localStorage.setItem( 'fieldOfStudyMap', JSON.stringify( this.fieldOfStudyMap ) );
					}
					localStorage.setItem( 'maxCredits', JSON.stringify( this.maxCredits || 5 ) );
				},

				// Course Listing Fuctions
				setSelectedCourse: function( course ) {
					this.selectedCourse = course;
					const notificationId = vmNotificationManager.addInfoNotification( 'Fetching course session information.' );
					ajaxLoadSessionsForSelectedCourse(notificationId);
				},
				addCourseIdToMyPlanIds: function( courseId ) {
					this.myPlanIds.push( courseId );
				},
				removeCourseIdFromMyPlanIds: function( courseId ) {
					this.myPlanIds.splice( this.myPlanIds.indexOf( courseId), 1 );
				},
				clearMyPlanIds: function() {
					this.myPlanIds = [];
				},

				// Review Request Functions
				getApprovalRequestFromCourseId: function( courseId ) {
					const filteredApprovalRequests = this.myApprovalRequests.filter( request => request.courseId == courseId );
					if ( filteredApprovalRequests.length ) {
						return filteredApprovalRequests[0];
					} else {
						return {
							approvalStatus: 'Not Sent',
							timestampCreated: '',
							timestampUpdated: '',
							sent: false,
							collapsed: true,
						};
					}
				},
                getApprovalRequestStatusFromCourseId: function( courseId ) {
                    const filteredApprovalRequests = this.myApprovalRequests.filter( request => request.courseId == courseId );
                    if ( filteredApprovalRequests.length ) {
                        return filteredApprovalRequests[0].approvalStatus || '';
                    } else {
                        return 'Not Sent';
                    }
                },
				getTitleForApprovalRequestStatus: function( status ) {
					switch (status) {
						case 'Not Sent':
							return 'Request Not Sent';
						case 'Sent':
							return 'Request Pending';
						case 'Expired':
							return 'Request Expired';
						case 'Reviewed':
							return 'Request Reviewed';
						case 'Accepted':
							return 'Request Accepted';
						case 'Suggested':
							return 'Course Suggested';
						case 'Completed':
							return 'Review Completed';
						default:
							return 'Request Corrupted';
					}
				},
				getApprovalRequestStatusTitleFromCourseId: function( courseId ) {
					return this.getTitleForApprovalRequestStatus(this.getApprovalRequestStatusFromCourseId(courseId));
				},
				getApprovalRequestCreatedFromCourseId: function( courseId ) {
					const filteredApprovalRequests = this.myApprovalRequests.filter( request => request.courseId == courseId );
                    if ( filteredApprovalRequests.length ) {
                        return filteredApprovalRequests[0].timestampCreated;
                    } else {
                        return 'Date Not Found';
                    }
				},
				getApprovalRequestUpdatedFromCourseId: function( courseId ) {
					const filteredApprovalRequests = this.myApprovalRequests.filter( request => request.courseId == courseId );
					if ( filteredApprovalRequests.length ) {
						return filteredApprovalRequests[0].timestampUpdated;
					} else {
						return false;
					}
				},
				showApprovalRequestDetailsForCourseId: function( courseId ) {
					return ( this.getApprovalRequestStatusFromCourseId( courseId ) != null );
				},
				getClassForApprovalRequest: function( request ) {
					if (request && request.approvalStatus) {
						return 'approval-' + request.approvalStatus.toLowerCase().replace(' ', '-');
					}
					return '';
				},
				getApprovalRequestClassForCourseId: function( courseId ) {
					if ( this.showApprovalRequestDetailsForCourseId( courseId ) ) {
						return 'approval-' + this.getApprovalRequestStatusFromCourseId( courseId ).toLowerCase().replace(' ', '-');
					}
					return '';
				},
				getEventVerbPhrase: function(event) {
					if (!event || !event.type_code)
						return 'did something';
					switch (event.type_code) {
						case 0: return 'did something';
						case 1: return 'commented';
						case 2: return 'added course';
						case 3: return 'requested review';
						case 4: return 'suggested course';
						case 5: return 'reviewed course';
						case 6: return 'accepted course';
						case 7: return 'marked course as completed';
						case 8: return 'unmarked course as completed';
						case 9: return 'dismissed course';
						case 10: return 'unaccepted course';
						default: break;
					}
					return 'did something';
				},
                isReadyForApprovalRequest: function( courseId ) {
                    const status = this.getApprovalRequestStatusFromCourseId( courseId );
                    if ( status == 'Reviewed' || status == 'Sent' ) {
                        return false;
                    } else {
                        return true;
                    }
                },
                sendApprovalRequest: function( courseId ) {
					// add local info
					this.myApprovalRequests = Array.prototype.slice.call( this.myApprovalRequests );

					this.myApprovalRequests.unshift( {
						courseId: courseId,
						approvalStatus: this.teacher ? 'Suggested' : (this.myProfile.autoRequestApproval ? 'Sent' : 'Not Sent'),
						timestampUpdated: false,
						timestampCreated: '-',
						courseInfo: {},
						id: null,
				 	} );

					$( '.approval-request-content-course-' + courseId ).collapse( 'show' );

					const notificationId = vmNotificationManager.addInfoNotification( 'Sending Review Request to the Server' );
					ajaxSendApprovalRequest( courseId, notificationId, this.teacher ? this.teacher.id : null );
                },
                sendApprovalRequestComment: function(approvalRequest, comment) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Sending Request Comment to the Server' );
					ajaxSendApprovalRequestComment(approvalRequest, comment, notificationId, this.teacher ? this.teacher.id : null);
                },
                sendApprovalRequestApproval: function(approvalRequest, comment) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Sending Request Approval to the Server' );
					ajaxAcceptApprovalRequest(approvalRequest, comment, notificationId, this.teacher ? this.teacher.id : null);
                },
				sendReviewComplete: function(approvalRequest, comment, eventId = null) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Sending Review Completion to the Server' );
					ajaxCompleteReview(approvalRequest, comment, notificationId, this.teacher ? this.teacher.id : null, eventId);
                },
				sendGetApprovalRequest: function(approvalRequest, repeatDelay = null) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Sending Request Approval to the Server' );
					ajaxGetApprovalRequest(approvalRequest, notificationId, this.teacher ? this.teacher.id : null);
					const timerId = 'id' in approvalRequest ? 'r' + approvalRequest.id : 'c' + approvalRequest.courseId;
					reviewRequestRefreshTimers[timerId] = setTimeout(() => {
						this.sendGetApprovalRequest(approvalRequest, repeatDelay || reviewRequestRefreshDelay);
					}, repeatDelay);
				},
				markApprovalRequestRead: function(approvalRequest, eventId = null) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Marking Request as Read at the Server' );
					ajaxSendMarkApprovalRequestRead(approvalRequest, notificationId, eventId, this.teacher ? this.teacher.id : null);
				},
				markAllApprovalRequestsRead: function() {
					const notificationId = vmNotificationManager.addInfoNotification('Marking All Teacher Requests as Read at the Server');
					ajaxSendMarkAllApprovalRequestsRead(notificationId, this.teacher ? this.teacher.id : null);
				},

				// myPlan functions
                addToMyPlan: function( courseId, completed ) {
                    // update the course directory buttons
                    vmGCQ.addCourseIdToMyPlanIds( courseId );
					// show the myplan tab
					$( '.dashboard-toggles .dashboard-toggle' ).click();

					const notificationId = vmNotificationManager.addInfoNotification( 'Adding course to MyPlan on the Server' );
					courseId = parseInt( courseId );
					ajaxAddToMyPlan( courseId, notificationId, completed, this.teacher ? this.teacher.id : null );

					// update the MyPlan view
					if ( completed ) {
						const course = vmGCQ.courseList.filter( course => course.id == courseId )[0] ||
							this.myPlan.filter( course => course.id == courseId )[0];
						if ( course ) {
							this.myPlanCompleted.push( course );
							this.myPlan = this.myPlan.filter( entry => entry.id != courseId );
							if (course.credits.length == 1) {
								this.completedCredits += parseInt(course.credits);
							}
							
						}
					 } else {
						const course = vmGCQ.courseList.filter( course => course.id == courseId )[0] ||
							this.myPlanCompleted.filter( course => course.id == courseId )[0];
						if ( course ) {
							this.myPlan.push( course );
							const index = this.myPlanCompleted.findIndex( entry => entry.id == courseId );
							if ( index >= 0 ) {
								this.myPlanCompleted = this.myPlanCompleted.filter( entry => entry.id != courseId );
								if (course.credits.length == 1) {
									this.completedCredits -= parseInt(course.credits);
								}
							}
						}
					}
                },
                clearMyPlan: function() {
                    // update the Course Directory buttons
                    vmGCQ.clearMyPlanIds();
                    // update the MyPlan view
                    this.myPlan = [];

                    const notificationId = vmNotificationManager.addInfoNotification( 'Clearing MyPlan on the server' );
					ajaxClearMyPlan( notificationId, this.teacher ? this.teacher.id : null );
                },
                removeFromMyPlan: function( courseId ) {
                    // update the Course Directory buttons
                    vmGCQ.removeCourseIdFromMyPlanIds( courseId );
                    // update the MyPlan view
                    this.myPlan = this.myPlan.filter( course => course.id != courseId );

                    const notificationId = vmNotificationManager.addInfoNotification( 'Removing course from MyPlan on the server' );
					ajaxRemoveFromMyPlan( courseId, notificationId, this.teacher ? this.teacher.id : null );
                },

				// Profile functions
				updateProfile: function() {

					if ( this.profileFields.phone.match(/\d/g).length != 10 ) {
						vmNotificationManager.addErrorNotification( 'Please enter a 10 digit phone number' );
						return;
					}

					// update local fields
					this.myProfile.firstName = this.profileFields.firstName;
					this.myProfile.lastName = this.profileFields.lastName;
					this.myProfile.phone = this.profileFields.phone;
					this.myProfile.schoolDistrict = this.profileFields.schoolDistrict;
					this.myProfile.schoolDistricts = this.profileFields.schoolDistricts;
					this.myProfile.state = this.profileFields.state;
					this.myProfile.dualCreditInstitutions = this.profileFields.dualCreditInstitutions;
					this.myProfile.dualCreditInstitution = this.profileFields.dualCreditInstitution;
					this.myProfile.approverEmail = this.profileFields.approverEmail;
					this.myProfile.approverName = this.profileFields.approverName;
					this.myProfile.autoRequestApproval = this.profileFields.autoRequestApproval;

					const notificationId = vmNotificationManager.addInfoNotification( 'Updating profile on the server' );

					ajaxUpdateProfile( notificationId );
				},

				changeOtherCompletedCredits: function(source) {
					this.setOtherCompletedCredits( parseInt( source.target.value ) );
				},

				setOtherCompletedCredits: function(value) {
					const oldCompletedCredits = this.completedCredits;
					this.completedCredits = this.myPlanCompletedCredits + value;
					//this._computedWatchers.otherCompletedCredits.run();

					const notificationId = vmNotificationManager.addInfoNotification( 'Updating completed on the server' );

					ajaxUpdateCompletedCredits( notificationId );
				},

				updateProfileImage: function() {
					const notificationId = vmNotificationManager.addInfoNotification( 'Updating profile image on the server' );

					ajaxUpdateProfileImage( notificationId );
				},

				saveTranscript: function() {
					const notificationId = vmNotificationManager.addInfoNotification( 'Saving transcript on the server' );

					ajaxUploadTranscript( notificationId );
				},

				updatePassword: function() {
					const notificationId = vmNotificationManager.addInfoNotification( 'Updating password on the server' );

					ajaxUpdatePassword( notificationId );
				},

				// Filter Functions

				scheduleLoadCourseList() {
					if ( undefined === this.ajaxFilters )
						return;
					if ( null !== loadSearchListTimeout )
						window.clearTimeout( loadSearchListTimeout );
					if ( null === loadCourseListPrenotificationId )
						loadCourseListPrenotificationId = vmNotificationManager.addInfoNotification( 'Waiting to Course List' );
					loadSearchListTimeout = window.setTimeout( function () {
						if ( null !== loadCourseListPrenotificationId )
							vmNotificationManager.removeNotification( loadCourseListPrenotificationId );
						if ( null === loadCourseListNotificationId )
							loadCourseListNotificationId = vmNotificationManager.addInfoNotification( 'Updating Course List' );
						ajaxLoadSearchLists( loadCourseListNotificationId );
					}, 0 );
				},
				setFieldOfStudy: function( fields ) {
					this.fieldOfStudyValues = fields;
					this.fieldOfStudySet = (fields && fields.length) ? new Set( fields ) : null;
					this.scheduleLoadCourseList();
				},
				toggleAvailableOnline: function() {
					this.availableOnline = ! this.availableOnline;
					if ( this.ajaxFilters )
					this.scheduleLoadCourseList();
				},
				setSessionDates: function( sessionDatesIds ) {
					this.sessionDatesIdsValues = sessionDatesIds;
					this.sessionDatesIdsSet = (sessionDatesIds && sessionDatesIds.length) ? new Set( sessionDatesIds ) : null;
					this.scheduleLoadCourseList();
				},
				setCredits: function( credits ) {
					this.creditsValues = credits;
					this.creditsSet = (credits && credits.length) ? new Set( credits ) : null;
					this.scheduleLoadCourseList();
				},
				setUniversity: function( values ) {
					this.universityValues = values;
					if (values && values.length) {
						this.universitySet = new Set();
						for (const value of values) {
							const parts = value.split(':');
							switch (parts[0]) {
								case 'id':
									this.universitySet.add( parseInt(parts[1]) );
									break;
								case 'state':
									for (const university of this.universityList) {
										if (university.state == parts[1])
											this.universitySet.add( university.id );
									}
									break;
							}
						}
					} else
						this.universitySet = null;

					this.scheduleLoadCourseList();
				},
				setTeacher: function( value ) {
					const notificationId = vmNotificationManager.addInfoNotification( 'Loading Teacher Profile' );
					vmGCQ.loadingTeacherPlan = true;
					ajaxLoadMyPlan( notificationId, value );
				},
				refilterSessionDatesByrange: function( earliestStartDate, latestEndDate ) {
					let list = this.sessionDatesList.filter( s => s.open );
					if ( earliestStartDate ) {
						list = list.filter( s => (s.start !== null ? s.start : s.end) >= earliestStartDate );
					}
					if ( latestEndDate ) {
						list = list.filter( s => (s.end !== null ? s.end : s.start) <= latestEndDate );
					}
					list = list.map( s => s.id );
					this.setSessionDates( list );
				},
				resetFilters: function() {
					this.fieldOfStudyValues = null;
					this.fieldOfStudySet = null;
					this.availableOnline = false;
					this.filterKeywords = '';
					this.creditsValues = null;
					this.creditsSet = null;
					this.universityValues = null;
					this.universitySet = null;
					this.sessionDatesIdsValues = null;
					this.sessionDatesIdsSet = null;
					this.earliestStartDate = null;
					this.latestEndDate = null;
				},
				// Pagination Functions
				incrementPage: function() {
					if ( this.page < this.maxNumPages ) {
						this.page = this.page + 1;
					}
				},

				changeSorting: function( event ) {
					this.sorting = (((event.target || {}).selectedOptions || [])[0] || {}).value;
				},

				toggleRequestCollapse(request, course) {
					const collapsed = request.collapsed = !request.collapsed;
					const id = 'approval-request-' + ('id' in request ? request.id : 'course-' + course.id);
					let c = document.getElementById(id).classList;
					if (c) {
						const timerId = 'id' in request ? 'r' + request.id : 'c' + request.courseId;
						if (collapsed) {
							c.add('collapse');
							if (timerId in reviewRequestRefreshTimers) {
								clearTimeout(reviewRequestRefreshTimers[timerId]);
								delete reviewRequestRefreshTimers[timerId];
							}
						} else {
							c.remove('collapse');
							this.sendGetApprovalRequest(request, reviewRequestRefreshDelay);
						}
					}
					return collapsed;
				},

				refreshMyPlan() {
					const teacherId = this.teacher ? this.teacher.id : null;
					const notificationId = vmNotificationManager.addInfoNotification(teacherId ? 'Refreshing Teacher Plan' : 'Refreshing My Plan');
					vmGCQ.refreshingMyPlan = true;
					ajaxLoadMyPlan(notificationId, teacherId);
				},
			},
			watch: {
				earliestStartDate(newValue, oldValue) {
					this.refilterSessionDatesByrange(newValue, this.latestEndDate);
				},
				latestEndDate(newValue, oldValue) {
					this.refilterSessionDatesByrange(this.earliestStartDate, newValue);
				},
			},
			"filters" : {
				NickNameBySchoolId(id) {
					try {
						if ('undefined' != typeof this && 'function' == typeof this.getNickNameBySchoolId)
							return this.getNickNameBySchoolId( id );

						if (typeof vmGCQ != 'undefined' && vmGCQ !== null && 'function' == typeof vmGCQ.getNickNameBySchoolId)
							return vmGCQ.getNickNameBySchoolId( id );
					} catch (e) {}

					return 'loading...';
				},
				FieldNameById(id) {
					try {
						if ('undefined' != typeof this && 'function' == typeof this.getFieldNameById)
							return this.getFieldNameById( id );

						if (typeof vmGCQ != 'undefined' && vmGCQ !== null && 'function' == typeof vmGCQ.getFieldNameById)
							return vmGCQ.getFieldNameById( id );
					} catch (e) {}

					return 'loading...';
				},
				FieldImageFilenameById(id) {
					try {
						if ('undefined' != typeof this && 'function' == typeof this.getFieldImageFilenameById)
							return this.getFieldImageFilenameById( id );

						if (typeof vmGCQ != 'undefined' && vmGCQ !== null && 'function' == typeof vmGCQ.getFieldImageFilenameById)
							return vmGCQ.getFieldImageFilenameById( id );
					} catch (e) {}

					return null;
				},
				DeliveryFromIdIfId(value) {
					try {
						if ('undefined' != typeof this && 'function' == typeof this.getDeliveryFromIdIfId)
							return this.getDeliveryFromIdIfId( value );

						if (typeof vmGCQ != 'undefined' && vmGCQ !== null && 'function' == typeof vmGCQ.getDeliveryFromIdIfId)
							return vmGCQ.getDeliveryFromIdIfId( value );
					} catch (e) {}

					return 'loading...';
				},
				SessionDatesIdsToString(sessionDatesIds) {
					try {
						return vmGCQ.convertSessionDatesIdsToString( sessionDatesIds );
					} catch (e) {
					}
					return 'loading...';
				},
				UTCDateTimeToLocal(date) {
					return new Date(date + 'Z').toString();
				},
			}
        });

    });

});
